pageId = 'projects-calendar-views-show'

$(document).on 'pjaxload#' + pageId, (e, $page, page) ->
  $('#nav-project').addClass 'active'